import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function SettingsAPI(): BringozApi {
  return {
    base: `/settings`,
    infiniteScroll: {
      address: `/settings`,
      cmd: 'GET'
    },
    actions: {
      getGeneralTasks: {
        address: 'internaltask',
        cmd: 'GET',
        updateable: false
      },
      updateGeneralTask: {
        address: 'internaltask',
        cmd: 'POST',
        updateable: false
      },
      getOms3plsSettings: {
        address: '3pls',
        cmd: 'GET',
        updateable: false
      },
      updateOms3plsSettings: {
        address: '3pls',
        cmd: 'PUT',
        updateable: false
      },
      getSiteMetadata: {
        address: 'metadata',
        cmd: 'GET',
        updateable: false
      },
      createMetadata: {
        address: 'metadata',
        cmd: 'PUT',
        updateable: false
      },
      updateMetadata: {
        address: 'metadata/{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteMetadata: {
        address: 'metadata/{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getDocuments: {
        address: 'document',
        cmd: 'GET',
        updateable: false
      },
      createDocument: {
        address: 'document',
        cmd: 'PUT',
        updateable: false
      },
      updateDocument: {
        address: 'document/{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteDocument: {
        address: 'document/{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getReminders: {
        address: 'reminder',
        cmd: 'GET',
        updateable: false
      },
      createReminder: {
        address: 'reminder',
        cmd: 'PUT',
        updateable: false
      },
      updateReminder: {
        address: 'reminder/{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteReminder: {
        address: 'reminder/{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getAllVehicleStatusChangeReason: {
        address: 'vehicleStatusChangeReason',
        cmd: 'GET',
        updateable: false
      },
      createVehicleStatusChangeReason: {
        address: 'vehicleStatusChangeReason',
        cmd: 'PUT',
        updateable: false
      },
      updateVehicleStatusChangeReason: {
        address: 'vehicleStatusChangeReason/{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteVehicleStatusChangeReason: {
        address: 'vehicleStatusChangeReason/{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getOneVehicleStatusChangeReason: {
        address: 'vehicleStatusChangeReason/{id}',
        cmd: 'GET',
        updateable: false
      },
      getAbsenceReasons: {
        address: 'absenceReason',
        cmd: 'GET',
        updateable: false
      },
      createAbsenceReason: {
        address: 'absenceReason',
        cmd: 'PUT',
        updateable: false
      },
      updateAbsenceReason: {
        address: 'absenceReason/{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteAbsenceReason: {
        address: 'absenceReason/{id}',
        cmd: 'DELETE',
        updateable: false
      },
      createBreakType: {
        address: 'breakType',
        cmd: 'PUT',
        updateable: false
      },
      updateBreakType: {
        address: 'breakType/{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteBreakType: {
        address: 'breakType/{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getPackageFields: {
        address: 'packageConfiguration/packageField',
        cmd: 'GET',
        updateable: false
      },
      createPackageField: {
        address: 'packageConfiguration/packageField',
        cmd: 'PUT',
        updateable: false
      },
      updatePackageField: {
        address: 'packageConfiguration/packageField/{fieldId}',
        cmd: 'POST',
        updateable: false
      },
      deletePackageField: {
        address: 'packageConfiguration/packageField/{fieldId}',
        cmd: 'DELETE',
        updateable: false
      },
      getAllPackageConfigurations: {
        address: 'packageConfiguration',
        cmd: 'GET',
        updateable: false
      },
      getOnePackageConfiguration: {
        address: 'packageConfiguration/{packageId}',
        cmd: 'GET',
        updateable: false
      },
      updatePackageConfiguration: {
        address: 'packageConfiguration/{id}',
        cmd: 'POST',
        updateable: false
      },
      createPackageConfiguration: {
        address: 'packageConfiguration',
        cmd: 'PUT',
        updateable: false
      },
      shipperAppConfig: {
        address: 'shipperAppConfig',
        cmd: 'GET',
        updateable: false
      },
      updateOrderShipperAppConfig: {
        address: 'shipperAppConfig/orderConfig',
        cmd: 'POST',
        updateable: false
      },
      updateCustomerShipperAppConfig: {
        address: 'shipperAppConfig/customerConfig',
        cmd: 'POST',
        updateable: false
      },
      updatePaymentShipperAppConfig: {
        address: 'shipperAppConfig/paymentConfig',
        cmd: 'POST',
        updateable: false
      },
      // addMembersToGroup : {
      //   address: 'rolesGroup/{groupId}/members/add',
      //   cmd: 'POST',
      //   updateable: false
      // },
      emailReportConfiguration: {
        address: 'emailReportConfiguration',
        cmd: 'GET',
        updateable: false
      },
      createEmailReportConfiguration: {
        address: 'emailReportConfiguration',
        cmd: 'PUT',
        updateable: false
      },
      updateEmailReportConfiguration: {
        address: 'emailReportConfiguration/{emailReportType}',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}

angular
  .module('bringoz.admin.site-preferences')
  .factory('SettingsAPI', SettingsAPI);
